import { Block } from '@gitbook/slate';

import { BLOCK_OPENAPI_SCHEMAS, type BlockOpenAPISchemasData } from '../types';

/**
 * Create an OpenAPI Schemas block referencing an OpenAPI specification.
 */
export function createOpenAPISchemasBlockWithRef(data: BlockOpenAPISchemasData): Block {
    const {
        // We group the schemas by default
        grouped = true,
        ...rest
    } = data;
    return Block.createVoid({
        type: BLOCK_OPENAPI_SCHEMAS,
        data: {
            ...rest,
            grouped,
        },
    });
}
